import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CachedProjectService } from "../../shared/services/cached-project.service";
import { Title } from "@angular/platform-browser";
import { take } from "rxjs/operators";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { AuthService } from "../../shared/services/auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { Project } from "../../models/project";
import { NzModalService } from "ng-zorro-antd/modal";
import { EditProjectDialogComponent } from "../project/dialogs/edit-project-dialog/edit-project-dialog.component";
import { AddJobDialogComponent } from "../project/dialogs/add-job-dialog/add-job-dialog.component";

@Component({
    selector: "app-project-view",
    templateUrl: "./project-view.component.html",
    styleUrls: ["./project-view.component.less"],
    standalone: false
})
export class ProjectViewComponent implements OnInit {
  private modalService = inject(NzModalService)

  project: Project;
  project_id: string = "";
  project_name: string = "";
  project_description: string = "";

  constructor(
    private route: ActivatedRoute,
    private cachedProjectService: CachedProjectService,
    private titleService: Title,
    public authService: AuthService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private notificationService: NzNotificationService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params["id"]) {
        this.project_id = params["id"]
        this.getProject()
      }
    });
  }

  getProject(forceRefresh: boolean = false){
    this.cachedProjectService
      .getProjectById(this.project_id, forceRefresh)
      .toPromise()
      .then((data) => {
        this.project = data;
        this.project_id = data["id"];
        this.project_name = data["name"];
        this.project_description = data["description"];
        this.cachedProjectService.setCurrentProject(data);
        this.titleService.setTitle(this.project_name);
      });
  }
  
  addJob() {
    this.modalService.create({
      nzContent: AddJobDialogComponent,
      nzWidth: 800,
      nzFooter: null,
      nzData: {
        projectId: this.project_id,
        projectName: this.project_name,
      },
    }).afterClose.pipe(take(1)).subscribe((added) => {
      if (added) {
        this.getProject(true);
      }
    });
  }

  submitNewJob() {
    window.open(`/project/${this.project_id}/job-submission`, "_blank");
  }

  openProjectDialog(){
    this.modalService.create({
      nzContent: EditProjectDialogComponent,
      nzData: {project: this.project}
    }).afterClose.pipe(take(1))
      .subscribe((updated) => {
        if (updated) {
          console.log('project updated prolly get again')
          this.getProject(true)
        }
      });
  }
}
